export const shadows = {
  zero: `0 1px 0 rgba(0,0,0, 0.08)`,
  one: `0 2px 4px rgba(0,0,0, 0.08)`,
  two: `0 4px 16px rgba(0,0,0, 0.12)`,
  three: `0 8px 32px rgba(0,0,0, 0.12)`,
};
